// Optimized carousel initialization
let featureCollectionCarousel = null;
let brandLogoCarousel = null;
let init = false;

// Initialize feature collection carousel immediately (above fold)
function initFeatureCollectionCarousel() {
  const carouselElement = document.querySelector('[data-bt-featured-collection-carousel]');
  if (carouselElement && !featureCollectionCarousel) {
    featureCollectionCarousel = new Swiper('[data-bt-featured-collection-carousel]', {
      slidesPerView: 2.5,
      spaceBetween: 10,
      freeMode: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 16,
          freeMode: false
        }
      }
    });
  }
}

// Initialize brand logo carousel lazily (below fold)
function initBrandLogoCarousel() {
  if (window.innerWidth <= 767) {
    if (!init) {
      init = true;
      const carouselElement = document.querySelector("[data-brand-logo-carousel]");
      if (carouselElement) {
        brandLogoCarousel = new Swiper("[data-brand-logo-carousel]", {
          slidesPerView: 2.5,
          spaceBetween: 10,
          freeMode: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          },
        });
      }
    }
  } else if (init && brandLogoCarousel) {
    brandLogoCarousel.destroy();
    init = false;
  }
}

// Initialize feature collection on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFeatureCollectionCarousel);
} else {
  initFeatureCollectionCarousel();
}

// Initialize brand logo carousel lazily
if ('requestIdleCallback' in window) {
  requestIdleCallback(initBrandLogoCarousel, { timeout: 2000 });
} else {
  setTimeout(initBrandLogoCarousel, 2000);
}

// Handle resize
let resizeTimer;
window.addEventListener("resize", function() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(initBrandLogoCarousel, 250);
});